import { ChevronLeft, ChevronRight } from "lucide-react";
import B2BSearchPopover from "@components/layouts/b2b/layout/SearchPopover";
import UserMenu from "@components/layouts/b2c/layout/UserMenu";
import { useAppNavigate } from "@utils/hooks/useAppNavigate";
import { Language } from "@modules/localizations/i18n";
import { SearchPopover } from "@components/layouts/content/SearchPopover";

const B2BNavBar = ({
  isB2bAllowed,
  isB2cAllowed,
  isB2b,
  onB2bChange,
  language,
  onLanguageToggle,
}: {
  isB2bAllowed?: boolean;
  isB2cAllowed?: boolean;
  isB2b?: boolean;
  onB2bChange?: () => void | Promise<void>;
  language?: Language;
  onLanguageToggle?: () => void;
}) => {
  const navigate = useAppNavigate();

  return (
    <nav className="flex h-full w-full items-center justify-between px-5 dark:bg-[#010D19]">
      <div className="flex items-center justify-center gap-x-2">
        <div className="flex items-center justify-center gap-x-6 dark:text-white">
          <ChevronRight
            size={25}
            className="cursor-pointer ltr:rotate-180"
            onClick={() => {
              navigate(-1);
            }}
          />
          <ChevronLeft
            size={25}
            className="cursor-pointer ltr:rotate-180"
            onClick={() => {
              navigate(1);
            }}
          />
        </div>
        <div>
          <SearchPopover isB2B={isB2b} />
        </div>
      </div>
      <div className="flex items-center justify-center">
        <UserMenu
          isB2bAllowed={isB2bAllowed}
          isB2cAllowed={isB2cAllowed}
          isB2b={isB2b}
          onB2bChange={onB2bChange}
          language={language}
          onLanguageToggle={onLanguageToggle}
        />
      </div>
    </nav>
  );
};

export default B2BNavBar;
